/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DuplicateProjectRequestPost } from '../../models/duplicate-project-request-post';
import { DuplicateProjectResponse } from '../../models/duplicate-project-response';

export interface ProjectsControllerDuplicateProject$Params {

/**
 * Project id.
 */
  id: string;
      body: DuplicateProjectRequestPost
}

export function projectsControllerDuplicateProject(http: HttpClient, rootUrl: string, params: ProjectsControllerDuplicateProject$Params, context?: HttpContext): Observable<StrictHttpResponse<DuplicateProjectResponse>> {
  const rb = new RequestBuilder(rootUrl, projectsControllerDuplicateProject.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DuplicateProjectResponse>;
    })
  );
}

projectsControllerDuplicateProject.PATH = '/planning-projects/v1/projects/{id}/duplicate';
